import React from "react";
import OrganisationsForm from "../../pages/UserManagement/Organisations/OrganisationsForm";
import OrganisationsList from "../../pages/UserManagement/Organisations/OrganisationsList";
import DepartmentForm from "../../pages/UserManagement/Department/DepartmentForm";
import DepartmentList from "../../pages/UserManagement/Department/DepartmentList";
import TeamsForm from "../../pages/UserManagement/Team/TeamsForms";
import TeamList from "../../pages/UserManagement/Team/TeamList";
import UserList from "../../pages/UserManagement/User/UserList";
import UserForm from "../../pages/UserManagement/User/UserForm";
import { app_modules, action_options } from "helpers/apps_modules_list";
import UsersTypeList from "pages/UserManagement/UserType/UserTypeList";
import ModuleList from "pages/UserManagement/Module/Module";
import AddModuleForm from "pages/UserManagement/Module/ModuleForm";

const UserManagementRoutes: any = [
  // Organisation
  {
    path: "/organisations-list",
    name: "Organisations List",
    component: <OrganisationsList />,
    permissions: {
      app_name: app_modules.user_management.app_name,
      module_name: app_modules.user_management.modules.organisation,
      action: action_options.view,
    },
  },
  {
    path: "/organisation-form",
    name: "Organisation Form",
    component: <OrganisationsForm />,
    permissions: {
      app_name: app_modules.user_management.app_name,
      module_name: app_modules.user_management.modules.organisation,
      action: action_options.create,
    },
  },
  {
    path: "/edit-organisation/:id",
    name: "Edit Organisation",
    component: <OrganisationsForm />,
    permissions: {
      app_name: app_modules.user_management.app_name,
      module_name: app_modules.user_management.modules.organisation,
      action: action_options.update,
    },
  },

  // Department
  {
    path: "/departments-list",
    name: "Departments List",
    component: <DepartmentList />,
    permissions: {
      app_name: app_modules.user_management.app_name,
      module_name: app_modules.user_management.modules.department,
      action: action_options.view,
    },
  },
  {
    path: "/department-form",
    name: "Department Form",
    component: <DepartmentForm />,
    permissions: {
      app_name: app_modules.user_management.app_name,
      module_name: app_modules.user_management.modules.department,
      action: action_options.create,
    },
  },
  {
    path: "/department-form/:id",
    name: "Edit Department",
    component: <DepartmentForm />,
    permissions: {
      app_name: app_modules.user_management.app_name,
      module_name: app_modules.user_management.modules.department,
      action: action_options.update,
    },
  },

  // Teams
  {
    path: "/team-list",
    name: "Team List",
    component: <TeamList />,
    permissions: {
      app_name: app_modules.user_management.app_name,
      module_name: app_modules.user_management.modules.team,
      action: action_options.view,
    },
  },
  {
    path: "/team-forms",
    name: "Team Form",
    component: <TeamsForm />,
    permissions: {
      app_name: app_modules.user_management.app_name,
      module_name: app_modules.user_management.modules.team,
      action: action_options.create,
    },
  },
  {
    path: "/team-forms/:id",
    name: "Edit Team",
    component: <TeamsForm />,
    permissions: {
      app_name: app_modules.user_management.app_name,
      module_name: app_modules.user_management.modules.team,
      action: action_options.update,
    },
  },

  // Users
  {
    path: "/user-list",
    name: "User List",
    component: <UserList />,
    permissions: {
      app_name: app_modules.user_management.app_name,
      module_name: app_modules.user_management.modules.user,
      action: action_options.view,
    },
  },
  {
    path: "/user-form",
    name: "User Form",
    component: <UserForm />,
    permissions: {
      app_name: app_modules.user_management.app_name,
      module_name: app_modules.user_management.modules.user,
      action: action_options.create,
    },
  },
  {
    path: "/user-form/:id",
    name: "Edit User",
    component: <UserForm />,
    permissions: {
      app_name: app_modules.user_management.app_name,
      module_name: app_modules.user_management.modules.user,
      action: action_options.update,
    },
  },
  {
    path: "/user-form/:id/permissions",
    name: "User Permissions",
    component: <UserForm page="permissions" />,
    permissions: {
      app_name: app_modules.user_management.app_name,
      module_name: app_modules.user_management.modules.user,
      action: action_options.update,
    },
  },

  // User Types
  {
    path: "/user-type",
    name: "User Types",
    component: <UsersTypeList />,
    permissions: {
      app_name: app_modules.user_management.app_name,
      module_name: app_modules.user_management.modules.user_types,
      action: action_options.view,
    },
  },

  // Modules
  {
    path: "/module-list",
    name: "Module List",
    component: <ModuleList />,
    permissions: {
      app_name: app_modules.user_management.app_name,
      module_name: app_modules.user_management.modules.module,
      action: action_options.view,
    },
  },
  {
    path: "/module-form",
    name: "Module Form",
    component: <AddModuleForm />,
    permissions: {
      app_name: app_modules.user_management.app_name,
      module_name: app_modules.user_management.modules.module,
      action: action_options.create,
    },
  },
  {
    path: "/edit-module-form",
    name: "Edit Module",
    component: <AddModuleForm />,
    permissions: {
      app_name: app_modules.user_management.app_name,
      module_name: app_modules.user_management.modules.module,
      action: action_options.update,
    },
  },
];

export default UserManagementRoutes;
